module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/8mill-inactive-3fca9ade1ec8537a4d691709bb4b3a9a.png";